import { render, staticRenderFns } from "./index.vue?vue&type=template&id=692626b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692626b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('692626b4')) {
      api.createRecord('692626b4', component.options)
    } else {
      api.reload('692626b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=692626b4&scoped=true", function () {
      api.rerender('692626b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/contracts/noContract/index.vue"
export default component.exports